export default function rand(basis, negative){
    const sub = negative ? basis / 2 : 0; 
    return Math.floor(Math.random() * basis) - sub;
}